import React from 'react';
import { Grid, Button, Dropdown, Card, Pagination, Input } from 'semantic-ui-react';
import Loading from '../loading';
import $ from "jquery";
import Server from '../../functions/server';
import ReadCookie from '../../functions/readcookies';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import Sales from './links/sales';
import Purchase from './links/purchases';
import Outwards from './links/outwards';
import Service from './links/Service';
import Inwards from './links/inwards';
import Adjustment from './links/adjustments';
import Credit from './links/credit';

class View extends React.Component {

  state = {
    data: [], val: 1, load: false, message: '', pageNumber: 0, type: 1,
    totalPages: 50, boundaryRange: 1, siblingRange: 1,
    showEllipsis: true, showFirstAndLastNav: true,
    showPreviousAndNextNav: true, orderElement: 'partno',
    sortingOrder: 'DESC', search: '', selectedBrand: 'ALL',
    hiddenColumnArray1: [10,11,12,13,14,15,16,17],
    hiddenColumnArray: [],
    stockValues: [], from_dates: '', to_dates: ''
  }

  componentDidMount() {
    this.getToday();
  }

  componentDidUpdate(props) {
    if (props.branch != this.props.branch) {
      this.getToday();
    }
  }

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){ dd='0'+dd; }
    if(mm < 10){ mm='0'+mm; }
    today = yyyy+'-'+mm+'-'+dd;
    let firstDay = yyyy+'-'+mm+'-01';
    this.setState({ to_date: today, from_date: firstDay });
    this.getInfo(1, firstDay, today, this.state.orderElement, this.state.sortingOrder);
  }

  handlePaginationChange = (e, { activePage }) => {
    this.getInfo(activePage, this.state.from_date, this.state.to_date, this.state.orderElement, this.state.sortingOrder);
  }

  sort(orderElement, sortingOrder) {
    if (sortingOrder == 'DESC') {
      this.getInfo(1, this.state.from_date, this.state.to_date, orderElement, 'ASC');
      this.setState({ sortingOrder: 'ASC' })
    }
    else {
      this.getInfo(1, this.state.from_date, this.state.to_date, orderElement, 'DESC');
      this.setState({ sortingOrder: 'DESC' })
    }
  }

  getInfo(pageNumber, fromDate, toDate, orderElement, sortingOrder) {
    let context = this;
    let selectedBranch = this.props.branch;
    let selectedBrand = this.state.selectedBrand;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    if (toDate) { }
    else { return; }
    if (fromDate != this.state.from_dates || toDate != this.state.to_dates) {
      this.getStockValues(fromDate, toDate);
    }
    this.setState({ load: true, message: 'Getting Stock Info!!!!' });
    let data1 = { 'from_date': fromDate, 'to_date': toDate, 'branch': selectedBranch,
                  'brand': selectedBrand, 'userId': userId, 'page': pageNumber, 'type': this.state.type,
                  'orderElement': orderElement, 'sortingOrder': sortingOrder, 'search': this.state.search };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'stockinfo/get.php',
      success: function(data)
      {
        console.log(data);
        console.log('popopopo');
        let totalPages = 0;
        context.setState({ load: false, });
        try {
          let totalAmount = 0;
          data = JSON.parse(data);
          data.map((c) => {
            totalPages = c.totalPages;
            let price = context.convertToNumber(c.mrp);
            let tax = context.convertToNumber(c.tax);
            totalAmount = totalAmount + (price + ((price * tax)/100));
           })
          context.setState({ data, totalPages, totalAmount, pageNumber });
          context.callChildMethod();
        } catch (e) {
        }
      },
      error: function(err) {
        console.log(err);
        console.log('lllllllllllllllllll');
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  getStockValues(fromDate, toDate) {
    let context = this;
    let selectedBranch = this.props.branch;
    let data1 = { 'from_date': fromDate, 'to_date': toDate, 'branch': selectedBranch };
    console.log(data1);
    this.setState({ from_dates: fromDate, to_dates: toDate })
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'stockinfo/getstockvalues.php',
      success: function(data) {
        console.log(data);
        console.log('popopop');
        try {
          data = JSON.parse(data);
          context.setState({ stockValues: data })
        } catch (e) {
          alert('Error')
        }
      },
      error: function(err) {
        alert('Error!!!');
      }
    });
  }

  onChangeHiddenColumn = (val) => event => {
    if (event.target.checked) { this.remove(val); }
    else { this.add(val); }
  }

  remove(value) {
    let hiddenColumnArray = this.state.hiddenColumnArray;
    let items = [];
    for (var i = 0; i < hiddenColumnArray.length; i++) {
      if (hiddenColumnArray[i] != value) {
        items.push(hiddenColumnArray[i]);
      }
    }
    this.setState({ hiddenColumnArray: items })
  }

  add(value) {
    let hiddenColumnArray = this.state.hiddenColumnArray;
    hiddenColumnArray.push(value);
    this.setState({ hiddenColumnArray: hiddenColumnArray })
  }

  exportData() {
    if (!this.props.menuPermission.exports) {
      alert('You Are Not Allow To Export!!!');
      return;
    }
    let fromDate = this.state.from_date;
    let toDate = this.state.to_date;
    let selectedBranch = this.props.branch;
    let selectedBrand = this.state.selectedBrand;
    let search = this.state.search;
    window.location = Server() + 'stockinfo/export.php?fromDate='+
    fromDate+'&toDate='+toDate+'&selectedBranch='+selectedBranch+'&selectedBrand='+selectedBrand+
    '&search='+search;
  }

  onChangeHandle = (type) => event => { this.setState({ [type]: event.target.value }) }

  brand = (f, { value }) => { this.setState({ selectedBrand: value }) }

  convertToNumber(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  makeDecimalPoint(value) {
    try {
      value = Number(value).toFixed(2);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  type = (type) => (f, { value }) => { this.setState({ [type]: value }) }

  render() {
    let iii = (this.convertToNumber(this.state.pageNumber) * 25);
    iii = 0;
    let type = [
      {key: 'ALL', text: 'ALL', value: 0},
      {key: 'Stocks', text: 'Stocks', value: 1},
      {key: 'Values', text: 'Values', value: 2},
    ]
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
          <div style={{display: 'flex'}}>
            <div style={{marginLeft: 5}}>
              <br/>
              <Input placeholder='Search' value={this.state.search} onChange={this.onChangeHandle('search')} />
            </div>
            <div style={{marginLeft: 5}}>
              <br/>
                <Dropdown search selection placeholder='Select Brand' onChange={this.brand}
                  options={this.props.brandOptions} value={this.state.selectedBrand} />
            </div>
            <div style={{marginLeft: 5}}>
              From Date<br/>
              <input type="date" id="date" value={this.state.from_date}
                onChange={this.handleChange('from_date')} style={{width: '100%', height: 35 }} />
            </div>
            <div style={{marginLeft: 5}}>
              To Date<br/>
              <input type="date" id="date" value={this.state.to_date} onChange={this.handleChange('to_date')}
                    style={{width: '100%', height: 35 }} />
            </div>
            <div style={{marginLeft: 5}}>
              View Type<br/>
              <Dropdown fluid onChange={this.type('type')}
                selection options={type} value={this.state.type}  />
            </div>
            <div style={{marginLeft: 5}}>
              <br/>
              <Button fluid primary
                onClick={this.getInfo.bind(this, 1, this.state.from_date, this.state.to_date, this.state.orderElement, this.state.sortingOrder)}>
                Go
              </Button>
            </div>
            <div style={{marginLeft: 5}}>
              <br/>
                <Button primary fluid onClick={this.exportData.bind(this)} style={{display: this.props.stockinfoexport}}>
                  Export
                </Button>
            </div>            
          </div>

              <table width='100%'>
                <tr>

                  <th id='th'><center>Opening Value</center></th>
                  <th id='th'><center>Closing Value</center></th>
                  <th id='th'><center>Sales Value</center></th>
                  <th id='th'><center>Purchase Value</center></th>
                  <th id='th'><center>Adjustment Value</center></th>
                  <th id='th'><center>Inbound Value</center></th>
                  <th id='th'><center>Outbound Value</center></th>

                </tr>
                { this.state.stockValues.map((v) => {
                    let outboundValue = this.convertToNumber(v.outbound_value);
                    let inboundValue = this.convertToNumber(v.inbound_value);
                    let outboundValueRequest = this.convertToNumber(v.request_in);
                    let inboundValueRequest = this.convertToNumber(v.request_out);
                    let closingValue = this.convertToNumber(v.closing_value);
                    let openingValue = this.convertToNumber(v.opening_value);
                    return (
                      <tr>
                        <td>{this.makeDecimalPoint(openingValue)}</td>
                        <td>{this.makeDecimalPoint(closingValue)}</td>
                        <td>{this.makeDecimalPoint(v.sales_value)}</td>
                        <td>{this.makeDecimalPoint(v.purchase_value)}</td>
                        <td>{this.makeDecimalPoint(v.adj_value)}</td>
                        <td>{this.makeDecimalPoint(inboundValue)}</td>
                        <td>{this.makeDecimalPoint(outboundValue)}</td>
                      </tr>
                    )
                  })
                }
              </table>
              
              <div>
                { this.state.type == 0 ?
                  (
                  <table width="100%" id="emp_table">
                  <tr class="tr_header" style={{backgroundColor: '#abb119'}}>
                    <th id='th'><center>Sino</center></th>
                    <th id='th'><center>Spare</center></th>
                    <th id='th'><center>Brand</center></th>
                    <th id='th'><center>Opening<br/>Stock</center></th>
                    <th id='th'><center>Opening<br/>Stock <br/>Val.</center></th>
                    <th id='th'><center>Closing<br/>Stock</center></th>
                    <th id='th'><center>Closing<br/>Stock<br/>Val.</center></th>
                    <th id='th'><center>Adjusted<br/>Stock</center></th>
                    <th id='th'><center>Adjusted<br/>Stock<br/>Val.</center></th>
                    <th id='th'><center>Purchase</center></th>
                    <th id='th'><center>Purchase<br/>val.</center></th>
                    <th id='th'><center>Sales</center></th>
                    <th id='th'><center>Sales Val.</center></th>
                    <th id='th'><center>Inwards</center></th>
                    <th id='th'><center>Inwards<br/>Val.</center></th>
                    <th id='th'><center>Outwards</center></th>
                    <th id='th'><center>Outwards<br/>Val.</center></th>
                    <th id='th'><center>Credit</center></th>
                    <th id='th'><center>Credit<br/>Val.</center></th>
                    <th id='th'><center>Service</center></th>
                    <th id='th'><center>Service<br/>Val.</center></th>
                    <th id='th'><center>Reserved <br/>Stock</center></th>
                    <th id='th'><center>Tax%</center></th>
                    <th id='th'><center>Rate</center></th>
                    <th id='th'><center>Tax <br/>Amount</center></th>
                    <th id='th'><center>Total</center></th>
                  </tr>
                    { this.state.data.length > 0 ?
                      (
                        this.state.data.map((z) =>
                        {
                          iii++;
                          let tax = Number(z.tax); let rate = Number(z.dnp); let closing = Number(z.closing);
                          let sales = Number(z.sales); let taxAmount = (tax * rate)/100;
                          let totalAmount = (rate + taxAmount);
                          return (
                            <tr id='tr'>
                              <td id='td'><center>{iii}</center></td>
                              <td id='td'>{z.partno+'-->'+z.spare_name}</td>
                              <td id='td'><center>{z.brand_name}</center></td>
                              <td id='td'><center>{z.opening}</center></td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.openingvalue)}</td>
                              <td id='td'><center>{z.closing}</center></td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.closingvalue)}</td>
                              <td id='td'>
                                <center>
                                  <Adjustment adjustment={z.adjusted_stock} fromDate={this.state.from_date} toDate={this.state.to_date}
                                  partno={z.partno} brand={z.brand_id} branch={this.props.branch} />
                                </center>
                              </td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.adjusted_stockvalue)}</td>
                              <td id='td'>
                                <center>
                                  <Purchase purchase={z.purchase} purchase1={z.purchase1} fromDate={this.state.from_date} toDate={this.state.to_date}
                                  partno={z.partno} brand={z.brand_id} branch={this.props.branch} />
                                </center>
                              </td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.purchasevalue)}</td>
                              <td id='td'>
                                <center>
                                  <Sales sales={z.sales} sales1={z.sales1} fromDate={this.state.from_date} toDate={this.state.to_date}
                                  partno={z.partno} brand={z.brand_id} branch={this.props.branch} />
                                </center>
                              </td>
                              <td id='td' align='right'>{Number(z.salesvalue).toFixed(2)}</td>
                              <td id='td'>
                                <center>
                                  <Inwards inbound={z.inbound} inbound1={z.inbound1} fromDate={this.state.from_date} toDate={this.state.to_date}
                                  partno={z.partno} brand={z.brand_id} branch={this.props.branch} />
                                </center>
                              </td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.inboundvalue)}</td>
                              <td id='td'>
                              <center>
                                <Outwards outbound={z.outbound} outbound1={z.outbound1}
                                fromDate={this.state.from_date} toDate={this.state.to_date}
                                partno={z.partno} brand={z.brand_id} branch={this.props.branch} />
                              </center>
                              </td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.outboundvalue)}</td>
                              <td id='td'>
                                <center>
                                  <Credit credit={z.credit} fromDate={this.state.from_date} 
                                  toDate={this.state.to_date} partno={z.partno} brand={z.brand_id} 
                                  branch={this.props.branch} />
                                </center>
                              </td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.creditvalue)}</td>

                              <td id='td'>
                                <center>
                                <Service service={z.service} fromDate={this.state.from_date} 
                                  toDate={this.state.to_date} partno={z.partno} brand={z.brand_id} 
                                  branch={this.props.branch} />
                                </center>
                              </td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.servicevalue)}</td>

                              <td id='td'><center>{z.reserved_stocks}</center></td>
                              <td id='td'><center>{z.tax+'%'}</center></td>
                              <td id='td' align='right'>{Number(z.dnp).toFixed(2)}</td>
                              <td id='td' align='right'>{Number(taxAmount).toFixed(2)}</td>
                              <td id='td' align='right'>{Number(totalAmount).toFixed(2)}</td>
                            </tr>
                          )
                        })
                      ) : 
                      (
                      <div>
                        
                      </div>
                      )
                    }
                  </table>
                  ) : 
                  (
                    <div>
                      { this.state.type == 1 ?
                            (
                              <table width="100%" id="emp_table">
                                <tr class="tr_header" style={{backgroundColor: '#abb119'}}>
                                  <th id='th'><center>Sino</center></th>
                                  <th id='th'><center>Spare</center></th>
                                  <th id='th'><center>Brand</center></th>
                                  <th id='th'><center>Opening<br/>Stock</center></th>
                                  <th id='th'><center>Closing<br/>Stock</center></th>
                                  <th id='th'><center>Adjusted<br/>Stock</center></th>
                                  <th id='th'><center>Purchase</center></th>
                                  <th id='th'><center>Sales</center></th>
                                  <th id='th'><center>Inwards</center></th>
                                  <th id='th'><center>Outwards</center></th>
                                  <th id='th'><center>Credit</center></th>
                                  <th id='th'><center>Service</center></th>
                                  <th id='th'><center>Reserved <br/>Stock</center></th>
                                  <th id='th'><center>Tax%</center></th>
                                  <th id='th'><center>Rate</center></th>
                                  <th id='th'><center>Tax <br/>Amount</center></th>
                                  <th id='th'><center>Total</center></th>
                                </tr>
                                { this.state.data.length > 0 ?
                                  (
                                    this.state.data.map((z) =>
                                    {
                                      iii++;
                                      let tax = Number(z.tax); let rate = Number(z.dnp); let closing = Number(z.closing);
                                      let sales = Number(z.sales); let taxAmount = (tax * rate)/100;
                                      let totalAmount = (rate + taxAmount);
                                      return (
                                        <tr id='tr'>
                                          <td id='td'><center>{iii}</center></td>
                                          <td id='td'>{z.partno+'-->'+z.spare_name}</td>
                                          <td id='td'><center>{z.brand_name}</center></td>
                                          <td id='td'><center>{z.opening}</center></td>
                                          <td id='td'><center>{z.closing}</center></td>
                                          <td id='td'>
                                            <center>
                                              <Adjustment adjustment={z.adjusted_stock} fromDate={this.state.from_date} toDate={this.state.to_date}
                                              partno={z.partno} brand={z.brand_id} branch={this.props.branch} />
                                            </center>
                                          </td>
                                          <td id='td'>
                                            <center>
                                              <Purchase purchase={z.purchase} purchase1={z.purchase1} fromDate={this.state.from_date} toDate={this.state.to_date}
                                              partno={z.partno} brand={z.brand_id} branch={this.props.branch} />
                                            </center>
                                          </td>
                                          <td id='td'>
                                            <center>
                                              <Sales sales={z.sales} sales1={z.sales1} fromDate={this.state.from_date} toDate={this.state.to_date}
                                              partno={z.partno} brand={z.brand_id} branch={this.props.branch} />
                                            </center>
                                          </td>
                                          <td id='td'>
                                            <center>
                                              <Inwards inbound={z.inbound} inbound1={z.inbound1} fromDate={this.state.from_date} toDate={this.state.to_date}
                                              partno={z.partno} brand={z.brand_id} branch={this.props.branch} />
                                            </center>
                                          </td>
                                          <td id='td'>
                                          <center>
                                            <Outwards outbound={z.outbound} outbound1={z.outbound1}
                                            fromDate={this.state.from_date} toDate={this.state.to_date}
                                            partno={z.partno} brand={z.brand_id} branch={this.props.branch} />
                                          </center>
                                          </td>
                                          <td id='td'>
                                            <center>
                                              <Credit credit={z.credit} fromDate={this.state.from_date} 
                                              toDate={this.state.to_date} partno={z.partno} brand={z.brand_id} 
                                              branch={this.props.branch} />
                                            </center>
                                          </td>
                                          <td>
                                            <center>
                                              <Service service={z.service} fromDate={this.state.from_date} 
                                                toDate={this.state.to_date} partno={z.partno} brand={z.brand_id} 
                                                branch={this.props.branch} />
                                            </center>
                                          </td>
                                          <td id='td'><center>{z.reserved_stocks}</center></td>
                                          <td id='td'><center>{z.tax+'%'}</center></td>
                                          <td id='td' align='right'>{Number(z.dnp).toFixed(2)}</td>
                                          <td id='td' align='right'>{Number(taxAmount).toFixed(2)}</td>
                                          <td id='td' align='right'>{Number(totalAmount).toFixed(2)}</td>
                                        </tr>
                                      )
                                    })
                                  ) : 
                                  (
                                  <div>
                                    
                                  </div>
                                  )
                                }
                              </table>
                            ):
                            (
                              <table width="100%" id="emp_table">
                  <tr class="tr_header" style={{backgroundColor: '#abb119'}}>
                    <th id='th'><center>Sino</center></th>
                    <th id='th'><center>Spare</center></th>
                    <th id='th'><center>Brand</center></th>
                    <th id='th'><center>Opening<br/>Stock <br/>Val.</center></th>
                    <th id='th'><center>Closing<br/>Stock<br/>Val.</center></th>
                    <th id='th'><center>Adjusted<br/>Stock<br/>Val.</center></th>
                    <th id='th'><center>Purchase<br/>val.</center></th>
                    <th id='th'><center>Sales Val.</center></th>
                    <th id='th'><center>Inwards<br/>Val.</center></th>
                    <th id='th'><center>Outwards<br/>Val.</center></th>
                    <th id='th'><center>Credit<br/>Val.</center></th>
                    <th id='th'><center>Service<br/>Val.</center></th>
                    <th id='th'><center>Tax%</center></th>
                    <th id='th'><center>Rate</center></th>
                    <th id='th'><center>Tax <br/>Amount</center></th>
                    <th id='th'><center>Total</center></th>
                  </tr>
                    { this.state.data.length > 0 ?
                      (
                        this.state.data.map((z) =>
                        {
                          iii++;
                          let tax = Number(z.tax); let rate = Number(z.dnp); let closing = Number(z.closing);
                          let sales = Number(z.sales); let taxAmount = (tax * rate)/100;
                          let totalAmount = (rate + taxAmount);
                          return (
                            <tr id='tr'>
                              <td id='td'><center>{iii}</center></td>
                              <td id='td'>{z.partno+'-->'+z.spare_name}</td>
                              <td id='td'><center>{z.brand_name}</center></td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.openingvalue)}</td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.closingvalue)}</td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.adjusted_stockvalue)}</td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.purchasevalue)}</td>
                              <td id='td' align='right'>{Number(z.salesvalue).toFixed(2)}</td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.inboundvalue)}</td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.outboundvalue)}</td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.creditvalue)}</td>
                              <td id='td' align='right'>{this.makeDecimalPoint(z.servicevalue)}</td>
                              <td id='td'><center>{z.tax+'%'}</center></td>
                              <td id='td' align='right'>{Number(z.dnp).toFixed(2)}</td>
                              <td id='td' align='right'>{Number(taxAmount).toFixed(2)}</td>
                              <td id='td' align='right'>{Number(totalAmount).toFixed(2)}</td>
                            </tr>
                          )
                        })
                      ) : 
                      (
                      <div>
                        
                      </div>
                      )
                    }
                  </table>
                            )
                        }
                    </div>
                  )

                }
                
              </div>
              <div align="right">
                <Pagination activePage={this.state.pageNumber} boundaryRange={this.state.boundaryRange}
                  onPageChange={this.handlePaginationChange} siblingRange={this.state.siblingRange}
                  totalPages={this.state.totalPages} ellipsisItem={this.state.showEllipsis ? undefined : null}
                  prevItem={this.state.showPreviousAndNextNav ? undefined : null}
                  nextItem={this.state.showPreviousAndNextNav ? undefined : null} />
              </div>
            
      </div>
    );
  }
}

export default View;
